/* Browser-only capabilities used for installation instructions, not for auth.
 * Deliberately never alters backend role policies or TWA/client identity. */
export function detectMobilePlatform(userAgent = "", maxTouchPoints = 0) {
  const ua = String(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(ua) ||
    (/Macintosh/i.test(ua) && Number(maxTouchPoints) > 1);
  const isAndroid = !isIOS && /Android/i.test(ua);
  return isIOS ? "ios" : isAndroid ? "android" : "other";
}

export function isSafariBrowser(userAgent = "") {
  const ua = String(userAgent);
  return /Safari\//i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/i.test(ua);
}
